import { View } from "react-native";
import Box from "../Box";
import { ProgressGauge } from "./ProgressGauge";
import { CHART_DIMENSIONS } from "./constants";

type GaugeData = {
	label: string;
	progress: number;
	value?: string;
	icon?: React.ReactNode;
};

type GaugeStatsProps = {
	gauges: GaugeData[];
	size?: "small" | "medium" | "large";
};

const ITEM_WIDTH = {
	small: 64,
	medium: 80,
	large: 96,
} as const;

export const GaugeStats = ({ gauges, size = "medium" }: GaugeStatsProps) => {
	const { gap } = CHART_DIMENSIONS.circularGaugeGrid;
	return (
		<Box
			flexDirection="row"
			flexWrap="wrap"
			justifyContent="center"
			alignSelf="center"
			style={{
				width: "100%",
				columnGap: gap,
				rowGap: gap,
			}}
		>
			{gauges.map((gauge, index) => (
				<View
					key={`${gauge.label}-${index}`}
					style={{
						width: ITEM_WIDTH[size],
						alignItems: "center",
					}}
				>
					<ProgressGauge
						label={gauge.label}
						progress={gauge.progress}
						value={gauge.value}
						size={size}
						asset={gauge.icon ? "icon" : "text"}
						icon={gauge.icon}
					/>
				</View>
			))}
		</Box>
	);
};
